import type { ReactNode } from 'react';
import styles from './auth.module.css';
import logo from '@/assets/hoseaus-logo.png';

/**
 * Immersives Matchday-Feld für Login/Registrierung: vollflächiges Vereinsgrün
 * mit Rasenstreifen, große Wortmarke + Gold-Eyebrow + Tagline, darunter die
 * ruhige weiße Formular-Karte. Der „eine mutige Ort" der App (frontend-design).
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className={styles.wrap}>
      <div className={styles.pitch} aria-hidden="true" />
      <div className={styles.inner}>
        <header className={styles.hero}>
          <img src={logo} alt="" className={styles.heroLogo} />
          <div className={styles.eyebrow}>Beer & Love - Tippspiel</div>
          <div className={styles.wordmark}>HoseAus</div>
          <p className={styles.tagline}>Love Tippen - Hate Racism</p>
        </header>
        <div className={styles.card}>{children}</div>
      </div>
    </div>
  );
}
